export enum ErrorsEnum{
    UNAUTHORIZED_USER_ERROR = 403
}